<template>
  <div
    class="father_box"
    v-loading="isnowreasver"
    element-loading-text="试卷正在组成中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-card class="main_form">
      <div>
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item title="考场设置" name="1">
            <div class="son_input">
              <div id="guide-page-four-one">
                <div class="bacle_input">
                  <h5>{{ examState === "true" ? "考试" : "练习" }}名称：</h5>
                  <el-input
                    v-model.trim="testname"
                    placeholder="请输入内容"
                    maxlength="30"
                    show-word-limit
                    class="standard_input"
                  ></el-input>
                </div>
                <div class="bacle_input">
                  <h5>{{ examState === "true" ? "考试" : "练习" }}时间：</h5>
                  <div class="block">
                    <el-date-picker
                      v-model="value1"
                      @change="timechange"
                      value-format="yyyy-MM-dd HH:mm"
                      class="standard_input"
                      type="datetimerange"
                      :picker-options="
                        $route.query.trainId ? pickerOptions : pickerOptions0
                      "
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @focus="obtainTime"
                      :default-time="[vehicleTime, '23:59:59']"
                    >
                    </el-date-picker>
                  </div>
                </div>
                <div class="bacle_input" v-if="$route.name == 'Papers'">
                  <h5>答题时长：</h5>
                  <el-input
                    v-model.trim="inputtesttime"
                    maxlength="3"
                    placeholder="不应低于60分钟"
                    class="standard_input"
                    @blur="checktesttime"
                  ></el-input>
                  <p>分钟</p>
                </div>
                <div class="bacle_input" v-if="$route.name == 'Papers'">
                  <h5>考试及格线：</h5>
                  <el-input
                    v-model.trim="qualified"
                    placeholder="请输入考试及格线"
                    class="standard_input"
                    @blur="checkqualified"
                  ></el-input>
                  <p>总分{{ reducesum }}分</p>
                </div>
                <!-- 2023/10/18 产品新增 -->
                <!-- <div class="bacle_input" v-if="$route.name == 'Papers'">
                  <h5>考试模式：</h5>
                  <el-radio-group v-model="modeRadio" @change="getExamNum">
                    <el-radio :label="1">单次考试</el-radio>
                    <el-radio :label="2"
                      >多次考试取最高分
                      <el-input
                        class="exam_num"
                        v-model.number="examNum"
                        :disabled="modeRadio == 1"
                        :maxlength="2"
                      ></el-input
                      >次
                    </el-radio>
                  </el-radio-group>
                  <p class="txt_exam">
                    (如设置2次，那么考生可以参与2次该场考试，取2次中最高得分做为本次考试成绩。)
                  </p>
                </div> -->
                <div class="bacle_input" v-if="$route.name == 'Papers'">
                  <template v-if="!$route.query.trainId">
                    <div class="icont_pop">
                      <h5>试卷显示：</h5>
                      <el-tooltip
                        class="item a"
                        effect="dark5"
                        placement="right"
                      >
                        <i class="iconfont icon-tishi"></i>
                        <div slot="content">
                          <p>
                            不设置：拥有任意一个科室相同的管理权限的管理员，在“在线试
                            卷”列表可以查看。
                            仅本人可见：组卷者本人登录考核云，在“在线试卷”列表可以查看。
                            超级管理员和本人可见：组卷者或超级管理员登录考核云，在“在线
                            试卷”列表可以查看。
                          </p>
                        </div>
                      </el-tooltip>
                    </div>
                    <el-radio-group v-model="radio3" class="standard_input">
                      <el-radio :label="-1">不设置</el-radio>
                      <el-radio :label="0">仅本人可见</el-radio>
                      <el-radio :label="1">超级管理员和本人可见</el-radio>
                    </el-radio-group>
                  </template>
                </div>
                <div class="bacle_input" v-if="$route.name == 'Papers'">
                  <h5>答题终端：</h5>
                  <el-radio-group v-model="radio1" class="standard_input">
                    <el-radio :label="9">电脑端和手机端均可答题</el-radio>
                    <el-radio :label="5">仅手机端可答题</el-radio>
                    <el-radio :label="4">仅电脑端可答题</el-radio>
                  </el-radio-group>
                </div>
                <!-- 2024/7/12 产品新增人脸识别  只有考试才有-->
                <div class="face_input" v-if="examState === 'true'">
                  <div class="face_hader">
                    <h5>人脸识别：</h5>
                    <p>目前仅支持手机端识别</p>
                  </div>
                  <div class="bacle_inputphone">
                    <el-radio-group
                      v-model="faceRadio"
                      class="standard_input"
                      @input="faceRadioChange('face')"
                    >
                      <el-radio :label="0">不开启</el-radio>
                      <el-radio :label="1">开启考前识别</el-radio>
                    </el-radio-group>
                    <p class="red" v-if="faceType == true">
                      请联系客服开启功能
                    </p>
                  </div>
                </div>

                <div
                  v-if="faceRadio == 1 && $route.name == 'Papers'"
                  class="bacle_input"
                >
                  <h5>监考员认证码：</h5>
                  <el-input
                    class="w180"
                    v-model.trim="facePsw"
                    maxlength="6"
                    placeholder="请设置6位数字密码"
                  ></el-input>
                </div>
                <p
                  class="note"
                  v-if="faceRadio == 1 && $route.name == 'Papers'"
                >
                  可在认证失败时输入监考员认证码手动完成识别
                </p>
                <!-- 2025/5/15 产品新增限制考试IP 只有考试才有-->
                <!-- <div class="face_input" v-if="examState === 'true'">
                  <div class="face_hader">
                    <h5>限制考试IP：</h5>
                  </div>
                  <div class="bacle_inputphone">
                    <el-radio-group
                      v-model="limitExam"
                      class="standard_input"
                      @input="faceRadioChange('ip')"
                    >
                      <el-radio :label="0">关闭</el-radio>
                      <el-radio :label="1">开启</el-radio>
                    </el-radio-group>
                    <p class="red" v-if="ipType == true">请联系客服开启功能</p>
                  </div>
                </div>
                <div
                  class="ip_view"
                  v-if="limitExam == 1 && $route.name == 'Papers'"
                >
                  <div class="ip_left">
                    <p>可用IP地址（段）：</p>
                    <el-button type="primary" @click="addIpLocation"
                      >新增可用ip地址</el-button
                    >
                  </div>
                  <div class="ip_right">
                    <div
                      v-for="(item, index) in IpArr"
                      :key="index"
                      class="ip_input"
                    >
                      <div class="ip_">
                        <el-input
                          v-model.number="item.IP1"
                          @change="limitDigit(item, index, 'IP1')"
                          maxlength="3"
                        ></el-input
                        >：
                        <el-input
                          v-model.number="item.IP2"
                          @change="limitDigit(item, index, 'IP2')"
                          maxlength="3"
                        ></el-input
                        >：
                        <el-input
                          v-model.number="item.IP3"
                          @change="limitDigit(item, index, 'IP3')"
                          maxlength="3"
                        ></el-input
                        >：(1-255)
                      </div>
                      <div class="notes_input">
                        <p>备注：</p>
                        <el-input
                          v-model="item.remark"
                          placeholder="请输入备注"
                        ></el-input>
                      </div>
                    </div>
                  </div>
                </div> -->
                <div
                  class="bacle_input"
                  v-if="radio1 != 4 && $route.name == 'Papers'"
                >
                  <h5>手机考试防作弊：</h5>
                  <div class="bacle_inputphone">
                    <el-radio-group v-model="radio" class="standard_input">
                      <el-radio :label="10">关闭</el-radio>
                      <el-radio :label="11">开启</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="isallowqieping" v-if="radio == 11 && radio1 != 4">
                  <p>允许考生切屏</p>
                  <el-select
                    v-model="cutscreen"
                    placeholder="请选择"
                    class="qiepingcishu"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <p>次</p>
                </div>
                <!-- 限制考生截屏 -->
                <div v-if="radio == 11 && radio1 != 4">
                  <div class="isallowqieping">
                    <p>限制考生截屏</p>
                    <el-select
                      v-model="screenshots"
                      placeholder="请选择"
                      class="qiepingcishu"
                    >
                      <el-option
                        v-for="item in screenshotsArr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                    <p>次</p>
                  </div>
                  <p class="prompt_text">仅在手机端，截屏将被强制交卷</p>
                </div>
                <el-input
                  v-if="radio == 11 && radio1 != 4"
                  v-model.trim="cheat_pwdinput"
                  placeholder="请设置6位数字密码"
                  maxlength="6"
                  class="cheat_pwdinput"
                  @blur="checkpassnum"
                ></el-input>
                <div
                  class="bacle_input"
                  v-if="
                    $route.name == 'Papers' &&
                    this.paperMode.indexOf('random_') == -1
                  "
                >
                  <h5>打乱试题顺序：</h5>
                  <el-radio-group v-model="radio4" class="standard_input">
                    <el-radio :label="0">关闭</el-radio>
                    <el-radio :label="1">开启</el-radio>
                  </el-radio-group>
                </div>
                <div class="bacle_input" v-if="$route.name == 'Papers'">
                  <div class="icont_hover">
                    <h5>自动发布成绩：</h5>
                    <el-tooltip class="item a" effect="dark6" placement="right">
                      <i class="iconfont icon-tishi"></i>
                      <div slot="content">
                        <p>
                          开启立即发布成绩功能后，在没有主观题的情况下，当考
                          生点击交卷后，系统自动评分并向考生发布成绩。
                          在有主观题的情况下，则需要人工批阅后才能发布成绩。
                        </p>
                      </div>
                    </el-tooltip>
                  </div>
                  <el-radio-group v-model="radio2" class="standard_input">
                    <el-radio :label="0">关闭</el-radio>
                    <el-radio :label="1">开启</el-radio>
                  </el-radio-group>
                </div>
                <div class="learning_time">
                  <h5>
                    {{
                      examState === "true" ? "考试" : "练习"
                    }}作答最低时间要求：
                  </h5>
                  <div>
                    <el-input
                      v-model.number="timeValue"
                      @change="numberChange"
                      maxlength="4"
                      placeholder="请输入作答时间最低要求"
                    ></el-input>
                    <p>
                      <span>分钟</span>(如设置30分钟，考生将不能在{{
                        examState === "true" ? "考试" : "练习"
                      }}开始30分钟内交卷，该时间应小于{{
                        examState === "true" ? "考试" : "练习"
                      }}时长，设置0为不生效)
                    </p>
                  </div>
                </div>
              </div>
              <div class="special_input" v-if="examState === 'true'">
                <h5>注意事项：</h5>
                <div class="special_box">
                  <el-input
                    type="textarea"
                    placeholder="请输入内容"
                    v-model.trim="textarea2"
                    class="text_field"
                    resize="none"
                  >
                  </el-input>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-card>

    <!-- 考生设置 -->
    <el-card class="main_form">
      <div>
        <el-collapse v-model="isactiveNames" @change="handleChange">
          <el-collapse-item
            :title="!$route.query.trainId ? '考生设置' : ''"
            name="1"
          >
            <Candidate
              v-if="!$route.query.trainId"
              ref="candidate"
              :editData="editType == true ? list_vip : 'null'"
            />
            <!-- 按钮 -->
            <div class="baic_content">
              <div class="operation">
                <el-button class="succ_btn" @click="cutcoms(2)"
                  >上一步</el-button
                >
                <el-button
                  type="success"
                  class="submit_btn"
                  v-if="
                    this.$parent.iseditmode === undefined &&
                    $route.name == 'Papers'
                  "
                  @click="release"
                  :loading="isrelease"
                  >发布试卷</el-button
                >
                <el-button
                  type="success"
                  class="submit_btn"
                  v-if="
                    this.$parent.iseditmode !== undefined &&
                    $route.name == 'Papers'
                  "
                  @click="savepaper"
                  :loading="isrelease"
                  >保存试卷</el-button
                >
                <el-button
                  type="success"
                  class="submit_btn"
                  v-if="
                    this.$parent.iseditmode === undefined &&
                    $route.name == 'Testpapers'
                  "
                  @click="release"
                  :loading="isrelease"
                  >生成练习</el-button
                >
                <el-button
                  type="success"
                  class="submit_btn"
                  v-if="
                    this.$parent.iseditmode !== undefined &&
                    $route.name == 'Testpapers'
                  "
                  @click="savepaper"
                  :loading="isrelease"
                  >保存练习</el-button
                >
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </el-card>
    <!-- 子组件弹窗 -->
    <!-- 试卷添加考生 -->
    <AddExamin ref="addpup" :cutcoms="cutcoms" />
    <FourPup ref="popup" :currentRow="currentRow" />
  </div>
</template>

<script>
import $guideSteps from "@/utils/guideSteps";
import $utils from "@/utils/commonUtils";
import { getStudentList } from "@/api/index";
import qs from "qs";
import { ManagerunLock } from "@/api/index.js";
import editqusetionbank from "@/api/editqusetionbank";
import getstudentlist from "@/api/questionbank";
import loginvuex from "@/store/index";
import FourPup from "./FourPup.vue"; //添加考生的弹窗
import training from "@/api/trainingApi";
import AddExamin from "./AddExamin.vue"; //从试卷添加考生的弹窗。
import Candidate from "../../../../../../components/addCandidate/Candidate.vue";
import axios from "axios";
export default {
  name: "Pagefour",
  props: ["cutcoms", "reducesum", "testname"],
  data() {
    return {
      AddExaminData: "", //试卷添加考生的默认数据。
      fourPupinitdata: "", //添加考生弹窗的默认参数。
      input: "",
      textarea: "",
      inputtestname: "", //考试名称
      activeNames: ["1"],
      isactiveNames: ["1"],
      currentRow: {},
      value1: [], //开始和结束的时间
      StartDatestr: "", //开始的时间
      EndDate: "", //
      testmodecode: "", // 组卷模式英文编码。
      inputtesttime: "120", //答题时间
      qualified: "", //及格线
      faceRadio: 0, // 0不开启人脸识别，1：开启人脸识别；
      facePsw: "", // 监考员认证码
      radio: 10, //手机考试防止作弊 10关闭11开启
      radio1: 9, //答题终端，显示的终端
      radio2: 0, //是否自动发布成绩
      radio3: -1, //试卷显示 默认为-1
      radio4: 0, //打乱试题顺序
      timeValue: 0, // 考试答题时间最低要求
      textarea2: "", // 注意事项
      Attention: this.textarea2, //注意事项
      getData: [],
      currentPage3: 1, //  当前页数
      pageSize: 10,
      total: 100,
      modeRadio: 1, // 考试模式单选
      examNum: 2, // 考试模式次数 选择多次默认2
      currentRowData: {},
      selected: false, //判断是否选中
      editType: false, // 编辑状态
      faceType: false, // 是否开启人脸识别拦截提示语
      ipType: false, // 是否开启IP拦截提示语
      isVip: "", // 0 否 1行
      limitExam: 0,
      IpArr: [
        { IP: "", IP1: "", IP2: "", IP3: "", remark: "" },
        { IP: "", IP1: "", IP2: "", IP3: "", remark: "" },
        { IP: "", IP1: "", IP2: "", IP3: "", remark: "" },
      ],
      formColumns: [
        {
          prop: "RealName",
          label: "考生姓名",
          // width: "90px",
        },
        {
          prop: "UserName",
          label: "考生账号",
          // width: "90px",
        },
        {
          prop: "DepartmentName",
          label: "科室名称",
          // width: "90px",
        },
        {
          prop: "PTitle",
          label: "职称",
          // width: "90px",
        },
        {
          prop: "Position",
          label: "职位",
          // width: "90px",
        },
        {
          prop: "Birthday1",
          label: "出生日期",
          // width: "90px",
        },
        {
          prop: "JobDate",
          label: "工作年限",
          // width: "90px",
        },
      ],
      options: [
        //切屏次数的选项
        {
          value: "0",
          label: "0",
        },
        {
          value: "1",
          label: "1",
        },
        {
          value: "2",
          label: "2",
        },
        {
          value: "3",
          label: "3",
        },
      ],
      examState: "", // 是否是考试进入
      cutscreen: 0, //切屏次数
      screenshots: 0, // 限制截屏次数
      screenshotsArr: [],
      cheat_pwdinput: "", //防作弊六位数字密码
      rendersum: [],
      multipleSelection: [],
      isrelease: false, //按钮加载防抖。
      isnowreasver: false, //正在发布试卷中，全局遮罩
      pickerOptions: {
        //禁用当前前面的时间日期
        disabledDate(time) {
          // 培训的限制
          const row = JSON.parse(localStorage.getItem("examRowTime"));
          if (row.begainTime) {
            const begainTime = row.begainTime;
            const endTime = row.endTime;
            return (
              time.getTime() < new Date(begainTime).getTime() ||
              time.getTime() > new Date(endTime).getTime()
            );
          }
        },
      },
      pickerOptions0: {
        // 禁用当前前面的时间日期
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      date: "",
      list_vip: [], // 新定义的数组
      isShow: false, // 判断是否展示搜索的表格
      vehicleTime: "", // 默认时分
      paperMode: "",
      driver: null,
    };
  },
  components: {
    FourPup,
    AddExamin,
    Candidate,
  },
  methods: {
    // 重置
    reset() {
      this.input = "";
      this.isShow = false;
      this.searchResult();
    },
    // 点击获取当前默认时间
    obtainTime() {
      let time = new Date(); // 当前时间
      let defaultendtime = new Date(time.getTime() + 1000 * 60 * 30); //开始时间往后延长30分钟。
      this.vehicleTime = this.$moment(defaultendtime).format("HH:mm:ss");
      // console.log(this.vehicleTime, "后半小时");
    },
    // 搜索查询
    searchResult() {
      let articles_array = JSON.parse(JSON.stringify(this.getData)); // 一进来获取的列表数据
      let searchString = this.input; // input的数据
      // console.log(searchString);
      if (searchString == "") {
        // 传空值的时候展示全部
        this.isShow = false;
        this.list_vip = articles_array;
      } else {
        this.isShow = true; // 展示查询出来的表格
        searchString = searchString.trim().toLowerCase();
        articles_array = articles_array.filter((item) => {
          return JSON.stringify(item).indexOf(searchString) != -1;
        });
        if (this.list_vip.length == 0) {
          this.$message.error(`未找到包含“${this.input}”信息的考生!
`);
          this.list_vip = JSON.parse(JSON.stringify(this.getData));
        } else {
          this.list_vip = articles_array;
        }
      }
    },
    handleChange(val) {
      // console.log(val);
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      // this.getDateList(); // 重新发起请求
    },
    //转换组卷模式
    refertestmode(testmode, unified) {
      switch (testmode + "" + unified) {
        case "智能组卷统一命题":
          return "unified_db";
        case "智能组卷随机命题":
          return "random_db";
          break;
        case "试卷组卷统一命题":
          return "unified_exam";
          break;
        case "试卷组卷随机命题":
          return "random_exam";
          break;
        case "权重组卷统一命题":
          return "unified_Proportion";
          break;
        case "权重组卷随机命题":
          return "random_Proportion";
          break;
        case "精准组卷手动命题":
          return "sg_db";
          break;
        case "难易度组卷统一命题":
          return "unified_difflever";
          break;
        case "难易度组卷随机命题":
          return "random_difflever";
          break;
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage3 = val;
    },
    pageData: (number, pageSize, data) => {
      const pageList = [];
      const start = pageSize * number - pageSize;
      const end = pageSize * number;
      for (let i = start; i < end; i++) {
        pageList.push(data[i]);
      }
      const list = pageList.filter((item) => item);
      return list;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length > 0) {
        this.selected = true;
      } else {
        this.selected = false;
      }
    },
    // 判断是否被选中
    onTableSelect(rows, row) {
      let selected = rows.length > 0 || rows.indexOf(row) !== 1;
      this.selected = selected;
    },
    checktesttime() {
      let reg = /^[0-9]*$/;
      if (!reg.test(this.inputtesttime)) {
        this.$message.error("请输入纯数字答题时长");
        this.inputtesttime = "";
      }
    },
    checkpassnum() {
      let reg = /^[0-9]*$/;
      if (!reg.test(this.cheat_pwdinput)) {
        this.$message.error("请输入纯数字密码");
        this.cheat_pwdinput = "";
      }
    },
    checkqualified() {
      let reg = /^[0-9]*$/;
      if (!reg.test(this.qualified)) {
        this.$message.error("请输入纯数字及格分数");
        this.qualified = "";
      }
      if (this.qualified > this.reducesum) {
        this.$message({
          showClose: true,
          message: `及格分数(${this.qualified}分)不能大于总分(${this.reducesum}分)！`,
          type: "warning",
        });
        this.qualified = "";
      }
    },
    translationtime() {
      let nowtime = new Date();
      let defaultstarttime = new Date(nowtime.getTime() + 1000 * 60 * 30); //开始时间往后延长30分钟。
      let defaultendtime = new Date(nowtime.getTime() + 1000 * 60 * 120); //开始时间往后延长30分钟。
      this.value1[0] =
        this.$moment(defaultstarttime).format("YYYY-MM-DD HH:mm");
      this.value1[1] = this.$moment(defaultendtime).format("YYYY-MM-DD HH:mm");
      this.StartDatestr = this.value1[0];
      this.EndDate = this.value1[1];
      // console.log(defaultstarttime, defaultendtime);
    },
    // 查看是否有开启人脸的权限 此处调取接口看是否是VIP才能使用此功能
    async faceRadioChange(t) {
      // 避免重复调取接口
      if (this.isVip) {
        if (this.isVip == 0) {
          // 非白名单
          this.faceType = true;
          this.ipType = true;
          this.faceRadio = 0;
          this.limitExam = 0;
        }
        return;
      }
      const obj = {
        type: t,
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await editqusetionbank.checkVip(obj);
      if (data.Status == 200) {
        this.isVip = data.Data.isVip;
        // console.log(this.isVip);
        if (data.Data.isVip == 0) {
          // 非白名单
          if (t === "face") {
            this.faceRadio = 0;
            this.faceType = true;
          } else {
            this.limitExam = 0;
            this.ipType = true;
          }
        }
      } else {
        this.$message.error(data.Msg);
        this.isVip = 0;
        this.faceType = true;
        this.ipType = true;
      }
      return;
      if (this.isVip == 0) {
        // 非白名单
        this.faceType = true;
        this.faceRadio = 0;
      }
    },
    // 限制必须是数字
    limitDigit(item, index, type) {
      var reg = /^\d+$/;
      if (type === "IP1" && (reg.test(item.IP1) == false || item.IP1 > 255)) {
        this.$message({
          message: "警告，请输入正确数字且不能大于255",
          type: "warning",
        });
        this.IpArr[index].IP1 = "";
      } else if (
        type === "IP2" &&
        (reg.test(item.IP1) == false || item.IP2 > 255)
      ) {
        this.$message({
          message: "警告，请输入正确数字且不能大于255",
          type: "warning",
        });
        this.IpArr[index].IP2 = "";
      } else if (
        type === "IP3" &&
        (reg.test(item.IP1) == false || item.IP3 > 255)
      ) {
        this.$message({
          message: "警告，请输入正确数字且不能大于255",
          type: "warning",
        });
        this.IpArr[index].IP3 = "";
      }
    },
    // 查看是否有开启人脸的权限
    async getCheckVip() {
      const obj = {
        hid: JSON.parse(loginvuex.state.userlist).hid,
      };
      const { data } = await editqusetionbank.checkVip(obj);
      if (data.Status == 200) {
        this.isVip = data.Data.isVip;
      } else {
        this.$message.error(data.Msg);
      }
      // console.log(data);
    },
    // 添加ip地址
    addIpLocation() {
      const obj = { IP: "", IP1: "", IP2: "", IP3: "", remark: "" };
      if (this.IpArr.length < 5) {
        this.IpArr.push(obj);
      } else {
        this.$message({
          message: "警告，最多只能添加五个",
          type: "warning",
        });
      }
    },
    // 去重
    unique() {
      let departArr = this.getData.map((item) => {
        return item.DepartmentName;
      });
      departArr = [...new Set(departArr)];
      return departArr.length;
    },
    // 发布试卷
    async release() {
      if (this.$route.query.trainId) {
        // 培训进来的
        const obj = {
          trainId: this.$route.query.trainId,
        };
        const { data } = await training.getTrainByID(obj);
        if (data.Status == 200) {
          this.getData = data.Data.studentArr.map((item) => {
            item.UserID = item.StudentID;
            return item;
          });
        } else {
          this.$message.error(data.Data);
        }
      } else {
        this.getData = this.$refs.candidate.getData; // 勾中考生
      }
      console.log(this.getData);

      //拦截时间
      if (this.value1 == "") {
        this.$message({
          message: "必须要添加时间",
          type: "warning",
        });
        return;
      }
      //拦截答题时长
      if (this.inputtesttime == "" || String(this.timeValue) == "") {
        let reg = /^[0-9]*$/;
        if (!reg.test(this.inputtesttime)) {
          this.$message.error("请输入纯数字答题时长");
          this.inputtesttime = "";
        }
        return;
      }
      // 拦截考生模式为空
      // if (this.modeRadio == 2 && String(this.examNum) == "") {
      //   this.$message.error("请输入考生模式次数");
      //   return;
      // }
      if (!this.qualified && this.$route.name == "Papers") {
        this.$message.warning("请先填写考试及格分");
        return;
      }
      //拦截及格线
      if (
        (this.qualified == "" || this.qualified > this.reducesum) &&
        this.$route.name == "Papers"
      ) {
        this.$message({
          message: `及格分数(${this.qualified}分)不能大于总分(${this.reducesum}分)！`,
          type: "warning",
        });
        return;
      }
      //手机防作弊密码拦截
      if (this.radio == 11) {
        let reg = /^\d{6}$/;
        if (this.cheat_pwdinput == "") {
          this.$message.error("请输入六位数纯数字手机防作弊密码");
          return;
        }
        if (!reg.test(this.cheat_pwdinput)) {
          this.$message.error("请输入六位数纯数字手机防作弊密码");
          this.cheat_pwdinput = "";
          return;
        }
      }
      // 拦截人脸识别开启未填写密码
      if (this.faceRadio == 1) {
        // 开启人脸
        let reg = /^\d{6}$/;
        if (this.facePsw == "") {
          this.$message.error("请输入六位数监考员认证密码");
          return;
        }
        if (!reg.test(this.facePsw)) {
          this.$message.error("请输入六位数监考员认证密码");
          this.facePsw = "";
          return;
        }
      }
      // 拦截限制考试IP
      if (this.limitExam == 1) {
        const newIpArr = this.IpArr.filter((item) => {
          item.IP = item.IP1 + item.IP2 + item.IP3;
          return item.IP;
        });
        if (newIpArr.length == 0) {
          this.$message.error("请输入可用ip地址");
          return;
        } else {
          let state = false;
          var r = /^\d+$/;
          newIpArr.forEach((item) => {
            if (
              r.test(item.IP1) == false ||
              r.test(item.IP2) == false ||
              r.test(item.IP3) == false
            ) {
              state = true;
            }
          });
          if (state == true) {
            this.$message.error("请输入完整ip地址");
            return;
          }
        }
      }
      //拦截考生
      if (
        (this.getData == "" || this.getData.length == 0) &&
        this.$parent.checkmode == "随机命题"
      ) {
        this.$message({
          message: "随机命题下必须要添加考生",
          type: "warning",
        });
        return;
      }
      let reqUser = this.getData.map((item) => {
        let res = {};
        res.UserID = item.UserID;
        return res;
      });
      let studentSetarr = this.getData.map((item) => {
        return item.UserID;
      });
      this.IpArr = this.IpArr.filter((item) => {
        item.IP = item.IP1 + item.IP2 + item.IP3;
        if (item.IP) {
          item.IP = `${item.IP1}.${item.IP2}.${item.IP3}.1~255`;
          return item;
        }
      });
      this.isrelease = true;
      this.isnowreasver = true;
      let examinationinfo = {
        IsRandomTest: this.radio4, // 是否打乱题序 1是，0否
        IsOrderAnswer: 0, //是否开启顺序答题，1开启，0关闭
        IsPublishAll: this.radio2, //是否自动发布成绩 1开启，0关闭
        ExamglName: this.testname, //  试卷名字
        PaperMode: null, //组卷模式
        PaperName: this.testname, //考试名称
        showType: this.radio3, //不限制，0仅自己,1自己和超级管理员
        StartDate: this.StartDatestr, //开始考试时间
        EndDate: this.EndDate, //结束考试时间
        LengthTime: this.inputtesttime, //考试时长
        limitSubmit: this.timeValue, // 考试作答时间最低要求
        examNum: this.modeRadio == 1 ? 1 : this.examNum, // 考试模式次数
        IsFace: this.faceRadio, // 0不开启人脸识别，1：开启人脸识别
        IsIP: this.limitExam, //0不限制 1 限制
        IP: this.limitExam == 1 ? this.IpArr : [],
        facePsw: this.faceRadio == 1 ? this.facePsw : "", //  监考员认证码
        PassScore: this.qualified, //及格分数
        TotalScore: `${this.reducesum}`, //总分  下面是注意事项
        Attention: this.textarea2,
        numtype: this.radio1, // 选择权限 手机和电脑端9，手机端，5，电脑端4
        cheattype: this.radio, // 防作弊，10关闭，11开启
        cheat_pwd: this.cheat_pwdinput, //防作弊密码  防作弊未开启的时候就是空
        cheat_number: this.cutscreen, //切屏次数
        cheat_captureNum: this.screenshots, // 新增截屏操作#
        ReadResults: 1, //是否显示答案 0不显示 1显示
        Frequency: 1, //考试次数
        FilterHour: "0", //几小时不重复
      };
      console.log(examinationinfo, "examinationinfo");
      if (this.$route.name == "Testpapers") {
        examinationinfo = {
          IsRandomTest: this.radio4, // 是否打乱题序 1是，0否
          IsOrderAnswer: 0, //是否开启顺序答题，1开启，0关闭
          IsPublishAll: this.radio2, //是否自动发布成绩 1开启，0关闭
          ExamglName: this.testname, //  试卷名字
          PaperMode: null, //组卷模式
          PaperName: this.testname, //考试名称
          showType: -1, //不限制，0仅自己,1自己和超级管理员
          StartDate: this.StartDatestr, //开始考试时间
          EndDate: this.EndDate, //结束考试时间
          LengthTime: "120", //考试时长
          PassScore: "1", //及格分数
          TotalScore: `${this.reducesum}`, //总分  下面是注意事项
          Attention: this.textarea2,
          IsIP: this.limitExam, //0不限制 1 限制
          IP: this.limitExam == 1 ? this.IpArr : [],
          numtype: this.radio1, // 选择权限 手机和电脑端9，手机端，5，电脑端4
          cheattype: this.radio, // 防作弊，10关闭，11开启
          cheat_pwd: this.cheat_pwdinput, //防作弊密码  防作弊未开启的时候就是空
          cheat_number: this.cutscreen, //切屏次数
          cheat_captureNum: this.screenshots, // 新增截屏操作#
          ReadResults: 1, //是否显示答案 0不显示 1显示
          Frequency: 1, //考试次数
          FilterHour: "0", //几小时不重复
        };
      }
      let parmars = {
        //智能组卷发送的数据。
        SeletedPaper: [], //选中的试卷ID数组
        SelectedApp: this.$parent.pagetworeq1, // *
        SelectCpt: this.$parent.pagetworeq2, //*
        seleteTest: [], //选择的试题的ID
        PcPaper: [], //排除试卷ID数组
        Style: this.$parent.pagethreereq,
        ExamInfo: {
          //考试信息数据
          info: examinationinfo,
          User: reqUser,
        },
        studentSet: studentSetarr,
        CookieApp: this.$parent.pagetworeq3, //*
        CookieCpt: this.$parent.pagetwodata, // *
        ExamType: this.$route.name == "Papers" ? 0 : 1, // 0考试 1练习 2纸质试卷
        softApp: this.$parent.softAppdata, //系列题库详情数组
      };
      let accurateparmars = {
        //精准组卷发送的数据。
        SeletedPaper: [], //选中的试卷ID数组
        SelectedApp: this.$parent.pagetworeq11, // *
        SelectCpt: this.$parent.pagetworeq33, //*
        seleteTest: this.$parent.pagetworeq22, //选择的试题的ID
        PcPaper: [], //排除试卷ID数组
        Style: this.$parent.pagethreereq,
        ExamInfo: {
          //考试信息数据
          info: examinationinfo,
          User: reqUser,
        },
        studentSet: studentSetarr,
        CookieApp: this.$parent.pagetworeq3, //*
        CookieCpt: this.$parent.pagetworeq44, // *
        ExamType: this.$route.name == "Papers" ? 0 : 1, // 0考试 1练习 2纸质试卷
        softApp: this.$parent.softAppdata, //系列题库详情数组
      };
      // 试卷组卷的参数
      let examParmars = {
        SeletedPaper: [], //选中的试卷ID数组
        SelectedApp: [], // *
        SelectCpt: [], //*
        seleteTest: [], //选择的试题的ID
        PcPaper: [], //排除试卷ID数组
        Style: this.$parent.examThreereq, //第三步的数据
        ExamInfo: {
          // 第四步的数据
          //考试信息数据
          info: examinationinfo,
          User: reqUser,
        },
        studentSet: studentSetarr,
        CookieApp: this.$parent.examPage3,
        CookieCpt: { PaperStyleID: this.$parent.examPage },
        ExamType: this.$route.name == "Papers" ? 0 : 1, // 0考试 1练习 2纸质试卷
        softApp: this.$parent.softApp,
      };
      // 权重组卷的config参数
      let CookieCpt_new = Object.assign({}, this.$parent.pagetwodata);
      let DroitArr_new = Object.assign({}, this.$parent.DroitArr);
      // console.log(DroitArr_new, 88888);
      let examWeightData = {
        SeletedPaper: [], //选中的试卷ID数组
        SelectedApp: this.$parent.pagetworeq1, // *
        SelectCpt: this.$parent.pagetworeq2, //*
        seleteTest: [], //选择的试题的ID
        PcPaper: [], //排除试卷ID数组
        Style: this.$parent.weightThreereq, //第三步的数据
        ExamInfo: {
          // 第四步的数据
          //考试信息数据
          info: examinationinfo,
          User: reqUser,
        },
        studentSet: studentSetarr,
        CookieApp: this.$parent.pagetworeq3, //*
        //   CookieCpt: CookieCpt_new.SJSTJ_YSFCDEB, // *
        CookieCpt: this.$parent.pagetworeq2,
        ExamType: this.$route.name == "Papers" ? 0 : 1, // 0考试 1练习 2纸质试卷
        softApp: this.$parent.softAppdata, //系列题库详情数组
        DroitArr: this.$parent.DroitArr,
        G_SlectedTestHt: this.$parent.G_SlectedTestHt,
        tempSelectCptArray: this.$parent.tempSelectCptArray,
        qzHTML: this.$parent.qzHTML,
      };
      let examParmarsData = JSON.stringify(examParmars);
      let parmarsdata = JSON.stringify(parmars);
      let weightData = JSON.stringify(examWeightData);
      // 试卷组卷
      let examList = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
        examMode: this.testmodecode,
        config: examParmarsData,
      };
      let date = {
        //智能组卷
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
        examMode: this.testmodecode,
        config: `${parmarsdata}`,
      };
      // 权重组卷
      let addData = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
        examMode: this.testmodecode,
        config: `${weightData}`,
      };
      let jingzhundate = {
        //精准
        SelectTestArr: JSON.stringify(this.$parent.pagetwodata),
        config: JSON.stringify(accurateparmars),
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.userlist).hid,
        examMode: this.testmodecode,
      };
      // 难易度组卷
      if (this.$parent.testmode === "智能组卷") {
        let res = await getstudentlist.setcreatePaper_test(date);
        //获取到数据后的操作。
        // console.log(res);
        if (res.data.Status === 200) {
          this.$parent.$parent.$children[0].getDatalist();
          this.$message({
            showClose: true,
            message: "试卷发布成功",
            type: "success",
          });
          if (this.testmodecode === "unified_db") {
            // 统一命题才有
            this.getCompareTest(res.data.Data.ExamID);
          }
          this.trainingReturn(res.data.Data.ExamID);
          // console.log(this.$parent);
        } else if (res.data.Status == "210") {
          console.log("进行提示");
          this.$confirm(res.data.Data, "提示", {
            confirmButtonText: "确定(返回试题设置)",
            type: "warning",
          })
            .then(() => {
              this.isrelease = false;
              this.isnowreasver = false;
              this.cutcoms(2);
            })
            .catch(() => {
              this.isrelease = false;
              this.isnowreasver = false;
              this.cutcoms(2);
            });
        } else {
          this.$confirm(res.data.Data, "提示", {
            confirmButtonText: "确定",
            type: "warning",
          })
            .then(() => {
              this.isrelease = false;
              this.isnowreasver = false;
            })
            .catch(() => {
              this.isrelease = false;
              this.isnowreasver = false;
            });
          return;
        }
      } else if (this.$parent.testmode === "试卷组卷") {
        let Data = await getstudentlist.setcreatePaper_papertest(examList);
        if (Data.data.Status === 200) {
          setTimeout(() => {
            this.$parent.$parent.$children[0].getDatalist();
            this.$message({
              showClose: true,
              message: "试卷发布成功",
              type: "success",
            });
            console.log(Data, "试卷组卷成功");

            this.trainingReturn(Data.data.Data.ExamID);
          }, 1000);
        } else if (Data.data.Status == "210") {
          console.log("进行提示");
          this.$confirm(Data.data.Data, "提示", {
            confirmButtonText: "确定(返回试题设置)",
            type: "warning",
          })
            .then(() => {
              this.isrelease = false;
              this.isnowreasver = false;
              this.cutcoms(2);
            })
            .catch(() => {
              this.isrelease = false;
              this.isnowreasver = false;
              this.cutcoms(2);
            });
        } else {
          this.$confirm(Data.data.Data, "提示", {
            confirmButtonText: "确定",
            type: "warning",
          })
            .then(() => {
              this.isrelease = false;
              this.isnowreasver = false;
            })
            .catch(() => {
              this.isrelease = false;
              this.isnowreasver = false;
            });
          return;
        }
      } else if (this.$parent.testmode === "精准组卷") {
        let Data = await getstudentlist.setcreatePaper_actest(jingzhundate);
        console.log(Data);
        if (Data.data.Status == 200) {
          setTimeout(() => {
            this.$parent.$parent.$children[0].getDatalist();
            this.$message({
              showClose: true,
              message: "试卷发布成功",
              type: "success",
            });
            this.trainingReturn(Data.data.Data.ExamID);
          }, 1000);
        } else {
          this.$confirm(Data.data.Data, "提示", {
            confirmButtonText: "确定",
            type: "warning",
          })
            .then(() => {
              this.isrelease = false;
              this.isnowreasver = false;
            })
            .catch(() => {
              this.isrelease = false;
              this.isnowreasver = false;
            });
          return;
        }
      } else if (this.$parent.testmode === "权重组卷") {
        let Data = await getstudentlist.setcreatePaper_weight(addData);
        if (Data.data.Status == "210") {
          console.log("进行提示");
          this.$confirm(Data.data.Data, "提示", {
            confirmButtonText: "确定(返回试题设置)",
            type: "warning",
          })
            .then(() => {
              this.isrelease = false;
              this.isnowreasver = false;
              this.cutcoms(1.3);
            })
            .catch(() => {
              this.isrelease = false;
              this.isnowreasver = false;
              this.cutcoms(1.3);
            });
          return;
        }
        // console.log(Data, "权重最终请求");
        if (Data.data.Status == "200") {
          setTimeout(() => {
            this.$parent.$parent.$children[0].getDatalist();
            this.$message({
              showClose: true,
              message: "试卷发布成功",
              type: "success",
            });
            this.trainingReturn(Data.data.Data.ExamID);
          }, 1000);
        } else {
          this.$confirm(Data.data.Data, "提示", {
            confirmButtonText: "确定",
            type: "warning",
          })
            .then(() => {
              this.isrelease = false;
              this.isnowreasver = false;
            })
            .catch(() => {
              this.isrelease = false;
              this.isnowreasver = false;
            });
          return;
        }
        console.log(this.$parent);
      } else if (this.$parent.testmode === "难易度组卷") {
        // console.log(date, "难易度组卷");
        const { data } = await getstudentlist.createPaper_diflever(date);
        if (data.Status == 200) {
          this.$parent.$parent.$children[0].getDatalist();
          this.$message({
            showClose: true,
            message: "试卷发布成功",
            type: "success",
          });
          this.trainingReturn(data.Data.examID);
        } else {
          this.$confirm(data.data.Data, "提示", {
            confirmButtonText: "确定",
            type: "warning",
          })
            .then(() => {
              this.isrelease = false;
              this.isnowreasver = false;
            })
            .catch(() => {
              this.isrelease = false;
              this.isnowreasver = false;
            });
          return;
        }
      }
    },
    // 此处调取查重接口判断是否有重复试题
    async getCompareTest(id) {
      const obj = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        examID: id,
      };
      const { data } = await getstudentlist.compareTest(obj);
      if (data.Status == 200) {
        let repeaObj = data.Data;
        repeaObj.examName = this.testname;
        repeaObj.ExamID = id;
        if (data.Data.repeatCount != 0) {
          // 有重复的
          sessionStorage.setItem("repeaObj", JSON.stringify(repeaObj));
          this.$parent.$parent.$children[0].removeWeight(); // 重复弹窗
        } else {
          sessionStorage.removeItem("repeaObj");
        }
      } else {
        this.$message.error(data.Msg);
      }
      // console.log(data, "查重");
    },
    // 添加科室
    async addExaminee() {
      this.$refs.popup.submit();
      this.$refs.popup.dialogVisibleObj.addExamineeShow = true;
    },
    // 从试卷添加考生
    addexamPaper() {
      this.$refs.addpup.inits();
    },
    timechange() {
      let nowtime = this.$moment(new Date()).format("YYYY-MM-DD HH:mm");
      let nowdifftime = this.$moment(nowtime).diff(this.value1[0], "minutes");
      if (nowdifftime > 0) {
        this.$message({
          showClose: true,
          message: `考试开始日期时间应大于当前日期时间(${nowtime})`,
          type: "warning",
        });
        this.translationtime(); //时间初始化处理
        return;
      }
      this.StartDatestr = this.value1[0];
      this.EndDate = this.value1[1];
      let difftime = this.$moment(this.EndDate).diff(
        this.StartDatestr,
        "minutes"
      ); //计算出来的考试时长
      // console.log(difftime, 0);
    },
    // 培训返回
    async trainingReturn(id) {
      if (this.$route.query.trainId) {
        // 培训的去向
        const obj = {
          trainId: this.$route.query.trainId,
          type: this.$route.query.type,
          typeId: id,
        };
        const { data } = await training.addTrainByID(obj);
        if (data.Status == 200) {
          this.$router.push({
            path: "manage",
            query: {
              trainId: this.$route.query.trainId,
              typeId: id,
            },
          });
        } else {
          this.$message.error(data.Data);
        }
      } else {
        this.$parent.back("success");
      }
    },
    // 单个删除 ===>源数据getData
    delectstudent(row, val) {
      this.currentRowData = row;
      let userID = row.UserName; // 根据考试账号去删除
      let index = this.getData.findIndex((zitem) => {
        // 找到对应的索引删除
        return userID == zitem.UserName;
      });
      this.currentRow = index;
      this.currentRowData.index = val;
      this.$refs.popup.deleteState = 0;
      this.$refs.popup.dialogVisibleObj.batchDelete = true;
    },
    // 批量删除
    delectArr() {
      if (this.multipleSelection.length < 1) {
        this.$refs.popup.deleteState = 2;
        this.$refs.popup.dialogVisibleObj.batchDelete = true;
      } else {
        this.$refs.popup.deleteState = 1;
        this.$refs.popup.dialogVisibleObj.batchDelete = true;
      }
    },
    //编辑模式进来，历史数据进行回传。
    peperrefer(stateobj) {
      this.value1[0] = this.$moment(stateobj.StartDate).format(
        "YYYY-MM-DD HH:mm"
      );
      this.value1[1] = this.$moment(stateobj.EndDate).format(
        "YYYY-MM-DD HH:mm"
      );
      //  this.testname = this.$parent.testname;
      // console.log(stateobj, "编辑要的数据-----------");
      this.inputtesttime = stateobj.LengthTime;
      this.timeValue = stateobj.limitSubmit; // 考试作答时间最低要求
      // this.modeRadio = stateobj.examNum == 1 ? 1:2
      this.examNum = stateobj.examNum; // 考试模式次数
      this.faceRadio = stateobj.IsFace; // 人脸识别状态回显
      // let ip = JSON.parse(stateobj.IP).map(item=>{
      //   return item
      // })
      if (stateobj.IP) {
        this.IpArr = JSON.parse(stateobj.IP); // 可用ip地址回显
      }
      this.limitExam = stateobj.IsIp;
      this.facePsw = stateobj.facePsw; // 人脸识别密码
      this.qualified = stateobj.PassScore;
      // console.log(this.qualified, "this.qualified");
      this.radio3 = stateobj.showType;
      this.cutscreen = stateobj.cheat_number; // 新增截屏操作#
      this.screenshots = stateobj.cheat_captureNum;
      this.cheat_pwdinput = stateobj.cheat_pwd;
      this.radio1 = stateobj.numtype;
      this.radio = stateobj.cheattype;
      this.radio4 = stateobj.IsRandomTest;
      this.radio2 = stateobj.IsPublishAll;
      this.textarea2 = stateobj.Attention;
      this.getData = stateobj.User[0].UserID == null ? [] : stateobj.User;
      this.list_vip = JSON.parse(JSON.stringify(this.getData));
      this.editType = true;
    },
    async savepaper() {
      //编辑模式下进来保存试卷
      //统一模式下，试卷所选的章节和类别不可以再更改，直接在父里面参数里面取就可以了。
      if (this.$route.query.trainId) {
        // 培训进来的
        const obj = {
          trainId: this.$route.query.trainId,
        };
        const { data } = await training.getTrainByID(obj);
        if (data.Status == 200) {
          this.getData = data.Data.studentArr.map((item) => {
            item.UserID = item.StudentID;
            return item;
          });
        } else {
          this.$message.error(data.Data);
        }
      } else {
        this.getData = this.$refs.candidate.getData; // 勾中考生
      }
      if (this.value1 == "") {
        this.$message({
          message: "必须要添加时间",
          type: "warning",
        });
        return;
      }
      if (!this.qualified && this.$route.name == "Papers") {
        this.$message.warning("请先填写考试及格分!");
        return;
      }
      //拦截及格线
      if (
        (this.qualified == "" || this.qualified > this.reducesum) &&
        this.$route.name == "Papers"
      ) {
        this.$message({
          message: `及格分数(${this.qualified}分)不能大于总分(${this.reducesum}分)！`,
          type: "warning",
        });
        return;
      }
      // 拦截限制考试IP
      if (this.limitExam == 1) {
        const newIpArr = this.IpArr.filter((item) => {
          item.IP = item.IP1 + item.IP2 + item.IP3;
          return item.IP;
        });
        if (newIpArr.length == 0) {
          this.$message.error("请输入可用ip地址");
          return;
        } else {
          let state = false;
          var r = /^\d+$/;
          newIpArr.forEach((item) => {
            if (
              r.test(item.IP1) == false ||
              r.test(item.IP2) == false ||
              r.test(item.IP3) == false
            ) {
              state = true;
            }
          });
          if (state == true) {
            this.$message.error("请输入完整ip地址");
            return;
          }
        }
      }
      //拦截考生
      if (
        (this.getData == "" || this.getData.length == 0) &&
        this.$parent.testinfomation.PaperModeName == "随机命题"
      ) {
        this.$message({
          message: "必须要添加考生",
          type: "warning",
        });
        return;
      }
      this.IpArr = this.IpArr.filter((item) => {
        item.IP = item.IP1 + item.IP2 + item.IP3;
        if (item.IP) {
          item.IP = `${item.IP1}.${item.IP2}.${item.IP3}.1~255`;
          return item;
        }
      });
      this.isrelease = true;
      this.isnowreasver = true;
      let examinationinfo = {
        info: {
          ExamID: this.$parent.paperinfomation[0].ExamID,
          MainPaperID: this.$parent.paperinfomation[0].MainPaperID,
          IsRandomTest: this.radio4, // 是否打乱题序 1是，0否
          IsOrderAnswer: 0, //是否开启顺序答题，1开启，0关闭
          IsPublishAll: this.radio2, //是否自动发布成绩 1开启，0关闭
          ExamglName: this.testname, //  试卷名字
          PaperMode: this.$parent.paperinfomation[0].PaperMode, //组卷模式
          PaperName: this.testname, //考试名称
          showType: this.radio3, //不限制，0仅自己,1自己和超级管理员
          StartDate: this.value1[0], //开始考试时间
          EndDate: this.value1[1], //结束考试时间
          LengthTime: this.inputtesttime, //考试时长
          limitSubmit: this.timeValue, // 考试作答时间最低要求
          examNum: this.modeRadio == 1 ? 1 : this.examNum, // 考试模式次数
          IsFace: this.faceRadio, // 0不开启人脸识别，1：开启人脸识别
          IsIP: this.limitExam, // 0不开启，1：开启
          IP: this.limitExam == 1 ? this.IpArr : [], // 可用IP地址
          facePsw: this.faceRadio == 1 ? this.facePsw : "", //  监考员认证码
          PassScore: this.qualified, //及格分数
          TotalScore: `${this.reducesum}`, //总分  下面是注意事项
          Attention: this.textarea2,
          // IP: [], //限制IP数组
          // IsIP: 0, //IsIP 0不限制 1 限制
          numtype: this.radio1, // 选择权限 手机和电脑端9，手机端，5，电脑端4
          cheattype: this.radio, // 防作弊，10关闭，11开启
          cheat_pwd: this.cheat_pwdinput, //防作弊密码  防作弊未开启的时候就是空
          cheat_number: this.cutscreen, //切屏次数
          cheat_captureNum: this.screenshots, // 新增截屏操作#
          ReadResults: 1, //是否显示答案 0不显示 1显示
          Frequency: 1, //考试次数
          FilterHour: "0", //几小时不重复
          examID: this.$parent.paperinfomation[0].ExamID,
          // User: this.$parent.paperinfomation[0].User,
          User: this.getData, // 4.6修改
        },
        User: this.getData,
        IsUpdata: true,
      };
      if (this.$route.name == "Testpapers") {
        examinationinfo = {
          info: {
            ExamID: this.$parent.paperinfomation[0].ExamID,
            MainPaperID: this.$parent.paperinfomation[0].MainPaperID,
            IsRandomTest: this.radio4, // 是否打乱题序 1是，0否
            IsOrderAnswer: 0, //是否开启顺序答题，1开启，0关闭
            IsPublishAll: this.radio2, //是否自动发布成绩 1开启，0关闭
            ExamglName: this.testname, //  试卷名字
            PaperMode: this.$parent.paperinfomation[0].PaperMode, //组卷模式
            PaperName: this.testname, //考试名称
            showType: this.radio3, //不限制，0仅自己,1自己和超级管理员
            StartDate: this.value1[0], //开始考试时间
            EndDate: this.value1[1], //结束考试时间
            LengthTime: "120", //考试时长
            PassScore: "1", //及格分数
            TotalScore: `${this.reducesum}`, //总分  下面是注意事项
            Attention: this.textarea2,
            IsIP: this.limitExam, //0不限制 1 限制
            IP: this.limitExam == 1 ? this.IpArr : [],
            numtype: this.radio1, // 选择权限 手机和电脑端9，手机端，5，电脑端4
            cheattype: this.radio, // 防作弊，10关闭，11开启
            cheat_pwd: this.cheat_pwdinput, //防作弊密码  防作弊未开启的时候就是空
            cheat_number: this.cutscreen, //切屏次数
            cheat_captureNum: this.screenshots, // 新增截屏操作#
            ReadResults: 1, //是否显示答案 0不显示 1显示
            Frequency: 1, //考试次数
            FilterHour: "0", //几小时不重复
            examID: this.$parent.paperinfomation[0].ExamID,
            User: this.getData, // 4.6 修改
          },
          User: this.getData,
          IsUpdata: true,
        };
      }
      let config = {};
      // console.log(this.$parent.testinfomation.PaperMode, "unified_difflever");
      if (
        this.$parent.testinfomation.PaperMode == "unified_db" ||
        this.$parent.testinfomation.PaperMode == "sg_db" ||
        this.$parent.testinfomation.PaperMode == "unified_exam" ||
        this.$parent.testinfomation.PaperMode == "unified_Proportion" ||
        this.$parent.testinfomation.PaperMode == "unified_difflever"
      ) {
        //统一命题下
        config.SeletedPaper = [];
        config.SelectedApp = Object.values(
          JSON.parse(this.$parent.paperinfomation[1].Config).CookieApp
        ).flat(2);
        config.SelectCpt = this.$parent.SelectCpt; //*
        config.seleteTest = [];
        config.PcPaper = [];
        config.Style = this.$parent.Style;
        config.ExamInfo = examinationinfo;
        config.studentSet = this.getData.map((item) => {
          return item.UserID;
        });
        config.CookieApp = JSON.parse(
          this.$parent.paperinfomation[1].Config
        ).CookieApp;
        config.CookieCpt = JSON.parse(
          this.$parent.paperinfomation[1].Config
        ).CookieCpt;
        config.ExamType = this.$route.name == "Papers" ? 0 : 1;
        config.softApp = JSON.parse(
          this.$parent.paperinfomation[1].Config
        ).SoftApp;
        if (this.$parent.testinfomation.PaperMode !== "unified_difflever") {
          // 非难易度
          this.$parent.savemodifystyle();
        }
      } else if (
        this.$parent.testinfomation.PaperMode == "random_db" ||
        this.$parent.testinfomation.PaperMode == "random_difflever"
      ) {
        //智能随机下
        config.SeletedPaper = [];
        config.SelectedApp = this.$parent.random_db_data.SelectedApp; //待改
        config.SelectCpt = this.$parent.random_db_data.SelectCpt; //*
        config.seleteTest = [];
        config.PcPaper = [];
        config.Style = this.$parent.random_db_data.Style;
        config.ExamInfo = examinationinfo;
        config.studentSet = this.getData.map((item) => {
          return item.UserID;
        });
        config.CookieApp = this.$parent.random_db_data.CookieApp;
        config.CookieCpt = this.$parent.random_db_data.CookieCpt;
        config.ExamType = this.$route.name == "Papers" ? 0 : 1;
        config.softApp = this.$parent.random_db_data.softApp;
      } else if (this.$parent.testinfomation.PaperMode == "random_Proportion") {
        //权重组卷随机模式下
        config.SeletedPaper = [];
        config.SelectedApp = Object.values(
          JSON.parse(this.$parent.paperinfomation[1].Config).CookieApp
        ).flat(2);
        config.SelectCpt = this.$parent.SelectCpt;
        config.seleteTest = [];
        config.PcPaper = [];
        config.Style = this.$parent.random_Proportion_data.Style;
        examinationinfo.info["oldExamID"] = examinationinfo.info.ExamID;
        examinationinfo.info["oldMaMainPaperID"] =
          examinationinfo.info.MainPaperID;
        config.ExamInfo = examinationinfo;
        config.studentSet = this.getData.map((item) => {
          return item.UserID;
        });
        config.CookieApp = this.$parent.random_Proportion_data.CookieApp;
        config.CookieCpt = this.$parent.random_Proportion_data.CookieCpt;
        config.ExamType = this.$route.name == "Papers" ? 0 : 1;
        config.softApp = this.$parent.random_Proportion_data.softApp;
        config.DroitArr = this.$parent.random_Proportion_data.DroitArr;
        config.G_SlectedTestHt =
          this.$parent.random_Proportion_data.G_SlectedTestHt;
        config.tempSelectCptArray =
          this.$parent.random_Proportion_data.tempSelectCptArray;
        config.qzHTML = this.$parent.random_Proportion_data.qzHTML;
      } else if (this.$parent.testinfomation.PaperMode == "random_exam") {
        //试卷组卷随机模式下
        config.SeletedPaper = [];
        config.SelectedApp = [];
        config.SelectCpt = this.$parent.random_exam_data.SelectCpt; //*
        config.seleteTest = [];
        config.PcPaper = [];
        config.Style = this.$parent.random_exam_data.Style;
        config.ExamInfo = examinationinfo;
        config.studentSet = this.getData.map((item) => {
          return item.UserID;
        });
        config.CookieApp = [];
        config.CookieCpt = this.$parent.random_exam_data.CookieCpt;
        config.ExamType = this.$route.name == "Papers" ? 0 : 1;
        config.softApp = this.$parent.random_exam_data.softApp;
      }
      let parm = {
        json: JSON.stringify(config),
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        _examID: this.$parent.testinfomation.ExamID,
      };
      let res;
      console.log(parm);
      if (
        this.$parent.testinfomation.PaperMode == "unified_difflever" ||
        this.$parent.testinfomation.PaperMode == "random_difflever"
      ) {
        // 难易度编辑
        // config.ExamInfo.studentSet = config.ExamInfo.User.map((item) => {
        //   return item.UserID;
        // });
        delete config.ExamInfo.User;
        const obj = {
          config: JSON.stringify(config),
          examMode: config.ExamInfo.info.PaperMode,
          _examID: this.$parent.testinfomation.ExamID,
          userID: JSON.parse(localStorage.getItem("userlist")).userID,
          guid: JSON.parse(localStorage.getItem("userlist")).guid,
          hid: JSON.parse(localStorage.getItem("userlist")).hid,
        };
        // console.log(obj, "parm", config);
        res = await editqusetionbank.editSaveTest(obj);
      }
      if (this.$parent.testinfomation.PaperMode == "sg_db") {
        res = await editqusetionbank.updatePaper(qs.stringify(parm));
      } else if (this.$parent.testinfomation.PaperMode == "random_Proportion") {
        parm.examMode = "random_Proportion";
        parm.json = undefined;
        (parm.config = JSON.stringify(config)),
          (res = await editqusetionbank.createPaper(qs.stringify(parm)));
      } else if (this.$parent.testinfomation.PaperMode == "random_exam") {
        res = await editqusetionbank.SavePaper(qs.stringify(parm));
      } else {
        // 智能随机组卷编辑
        res = await editqusetionbank.Savestudent(qs.stringify(parm));
      }
      if (res.data.Status == 200) {
        // console.log(this.$route.name, "???");

        // 2024/7/3 编辑成功后开启考场
        const rowExam = JSON.parse(localStorage.getItem("rowExam"));
        if (rowExam && this.$route.name == "Papers") {
          const { data } = await ManagerunLock(rowExam);
          if (data.Status == 200) {
            localStorage.removeItem("rowExam");
            this.isnowreasver = false;
            this.isrelease = false;
            this.$message({
              showClose: true,
              message: "编辑修改成功",
            });
            this.$parent.$parent.$children[0].getDatalist();
            // this.$parent.back();
            let lxszRow = sessionStorage.getItem("lxszRow");
            // 此处判断是为了练习监控跳转查看编辑两种情况返回页面

            if (this.$route.query.trainId) {
              this.$router.push({
                path: "manage",
                query: {
                  trainId: this.$route.query.trainId,
                  typeId: this.$route.query.typeId,
                },
              });
            } else if (lxszRow !== null) {
              sessionStorage.removeItem("lxszRow");
              this.$router.push("/practiceWatch");
            } else {
              this.$parent.back();
            }
            // console.log(this.$parent.backpage);
          } else {
            this.$message.error(data);
          }
        } else {
          this.isnowreasver = false;
          this.isrelease = false;
          if (this.$route.query.trainId) {
            this.$router.push({
              path: "manage",
              query: {
                trainId: this.$route.query.trainId,
                typeId: this.$route.query.typeId,
              },
            });
          } else {
            this.$router.push("/practiceWatch");
          }
        }
      } else if (res.data.Status == 211) {
        // this.$message.error(
        //   "考试时间不能小于当前时间且考试时间已超过当前时间，不能修改"
        // );
        this.$message.error(res.data.Data);
        this.isrelease = false;
        this.isnowreasver = false;
      } else if (res.data.Status == 210) {
        this.$confirm(res.data.Data, "提示", {
          confirmButtonText: "确定",
          type: "warning",
        })
          .then(() => {
            this.isrelease = false;
            this.isnowreasver = false;
            this.cutcoms(1);
          })
          .catch(() => {
            this.isrelease = false;
            this.isnowreasver = false;
          });
        return;
      } else {
        this.$confirm(res.data.Data, "提示", {
          confirmButtonText: "确定",
          type: "warning",
        })
          .then(() => {
            this.isrelease = false;
            this.isnowreasver = false;
          })
          .catch(() => {
            this.isrelease = false;
            this.isnowreasver = false;
          });
      }
    },
    numberChange() {
      if (typeof this.timeValue !== "number") {
        this.$message({
          message: "警告，考试作答时间必须为数字，单位为分钟",
          type: "warning",
        });
        this.timeValue = 0;
      }
      if (this.timeValue > this.inputtesttime) {
        this.$message({
          message: "警告，考试作答时间必须小于答题时长，单位为分钟",
          type: "warning",
        });
        this.timeValue = 0;
      }
    },
    // 切换单次和多次的默认值
    getExamNum() {
      if (this.modeRadio == 2 && (!this.examNum || this.examNum < 2)) {
        this.examNum = 2;
      }
      // console.log(this.modeRadio);
    },
  },
  created() {
    // console.log("=========进入了pagefour.vue页面", this.$parent.iseditmode);
    if (this.$parent.iseditmode !== undefined) {
      this.paperMode = this.$parent.testinfomation.PaperMode;
      // console.log("执行了==========pageFour", this.$parent.paperinfomation[0]);
      //编辑模式下进来。
      this.peperrefer(this.$parent.paperinfomation[0]);
      return;
    }
    // console.log(this.$parent.testmode, this.$parent.checkmode);
    this.testmodecode = this.refertestmode(
      this.$parent.testmode,
      this.$parent.checkmode
    );
    this.paperMode = this.testmodecode;
    this.textarea2 =
      '1、请核对自己的编号(准考证号)，姓名等基本资料是否属实，如有错误请举手向监考老师示意；\n2、请注意答题时间，当倒计时时间为0，系统自动收卷；\n3、如遇电脑问题、网络问题、或电脑死机等情况，请举手向监考老师示意；\n4、请注意考场环境，保持安静，请勿相互交头接耳；\n5、请在提交试卷后看到"恭喜，您的考试成绩如下"或"考试结束，您的成绩提交成功"后方可离开考场.';
  },
  //被keep-alive组件包裹时使用
  async activated() {
    let guideSteps = await $utils.getUserGuideList("zxksPageFourSteps");
    this.examState = sessionStorage.getItem("examState"); // 是否是考试进入
    this.driver = $utils.getGuideDriver();
    // this.getCheckVip() // 查看是否有开启人脸的权限
    setTimeout(() => {
      this.$nextTick(() => {
        $utils.initGuideDriver(this.driver, guideSteps);
      });
    }, 1000);
    // 生成考生截屏次数label和value
    for (var i = 0; i < 11; i++) {
      this.screenshotsArr.push(i);
    }
    this.screenshotsArr = this.screenshotsArr.map((item) => {
      return { label: item, value: item };
    });
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.father_box {
  margin-top: 24px;
}
.w180 {
  width: 180px;
}
.note {
  padding-left: 20px;
  color: #bdaaaa;
  font-size: 14px;
  &::before {
    content: "*";
    width: 20px;
    display: inline-block;
    color: #bdaaaa;
  }
}
.face_input {
  display: flex;
  margin-top: 30px;
  padding-right: 40px;
  .face_hader {
    padding-left: 20px;
    > h5 {
      display: inline-block;
      min-width: 142px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      text-align: left;
      line-height: 40px;
      &::before {
        content: "*";
        width: 20px;
        display: inline-block;
        color: #ff0000;
      }
      &:nth-child(3) {
        margin-left: 57px;
      }
    }
    p {
      color: #bdaaaa;
      font-size: 14px;
      &::before {
        content: "*";
        width: 20px;
        display: inline-block;
        color: #bdaaaa;
      }
    }
  }
  .el-radio-group {
    margin-top: 16px;
  }
}
.baic_content {
  background-color: white;
  //  margin-top: 24px;
  min-width: 1527px;
  padding-bottom: 50px;
  border-radius: 4px 4px 4px 4px;

  .bacle_input {
    display: flex;
    margin-top: 30px;
    padding-right: 40px;
    h5 {
      display: inline-block;
      min-width: 142px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      text-align: left;
      line-height: 40px;
      padding-left: 20px;
      &::before {
        content: "*";
        width: 20px;
        display: inline-block;
        color: #ff0000;
      }
      &:nth-child(3) {
        margin-left: 57px;
      }
    }
    .el-button {
      width: 162px;
      height: 40px;
      background: #1890ff;
      opacity: 1;
      border-radius: 4px;
      margin-left: 30px;
      color: #ffffff;
    }
  }
  .check_textarea {
    width: 825px;
    ::v-deep .el-textarea__inner {
      width: 825px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
  .check_input {
    width: 632px;
    ::v-deep .el-textarea__inner {
      width: 632px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
}
::v-deep .el-textarea .el-input__count {
  position: absolute;
  bottom: 12px;
  right: 18px;
}
::v-deep .el-textarea__inner {
  line-height: 28px !important;
}
.prompt {
  width: 147px;
  height: 28px;
  padding: 2px 1px;
}
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 60px 0 70px 0;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-card__body {
  padding: 0;
}
::v-deep .el-collapse-item__header {
  height: 60px;
  line-height: 60px !important;
  background: #d8edff;
  border-radius: 10px 10px 0px 0px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 19px;
  color: #333333;
  padding: 0px 24px;
}
.main_form {
  border-radius: 13px 13px 0px 0px;
  margin-bottom: 24px;
  ::v-deep .el-collapse-item__arrow {
    font-weight: bolder;
  }

  .son_input {
    // height: 500px;
    .bacle_input {
      align-items: center;
      .standard_input {
        width: 825px;
        height: 40px;
        display: flex;
        align-items: center;
      }
      .text_field {
        width: 673px;
        height: 126px;
      }
      margin-top: 24px;
      padding-right: 40px;
      display: flex;
      p {
        margin-left: 20px;
      }
      h5 {
        min-width: 160px;
        font-size: 15px;
        font-family: PingFang SC;
        font-weight: 400;
        text-align: left;
        line-height: 40px;
        padding-left: 20px;
        margin-right: 10px;
        &::before {
          content: "*";
          width: 20px;
          display: inline-block;
          color: #ff0000;
        }
      }
      .icont_pop {
        position: relative;
        i {
          display: inline-block;
          position: absolute;
          right: 34px;
          top: 0px;
          color: #d9d9d9;
          // transform: scale(0.6);
          font-size: 20px;
          color: #d8edff;
        }
      }
      .icont_hover {
        position: relative;
        i {
          display: inline-block;
          position: absolute;
          right: 6px;
          top: 0px;
          color: #d9d9d9;
          // transform: scale(0.6);
          font-size: 20px;
          color: #d8edff;
        }
      }
    }
  }
}
.isallowqieping {
  width: 280px;
  display: flex;
  align-items: center;
  margin-left: 170px;
  margin-bottom: 12px;
  > p {
    font-size: 16px;
    color: rgb(160, 158, 158);
  }
  .qiepingcishu {
    width: 60px;
  }
}
.prompt_text {
  margin-left: 170px;
  font-size: 12px;
  color: rgb(160, 158, 158);
}
.cheat_pwdinput {
  width: 200px;
  margin-left: 170px;
  margin-top: 10px;
}
.special_input {
  display: flex;
  margin-top: 24px;
  .special_box {
    width: 673px;
    height: 126px;
    ::v-deep .el-textarea__inner {
      height: 120px;
    }
  }
  h5 {
    min-width: 160px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: left;
    line-height: 40px;
    padding-left: 20px;
    &::before {
      content: "*";
      width: 20px;
      display: inline-block;
      color: #ff0000;
    }
  }
}
.title_box {
  display: flex;
  justify-content: space-between;
  margin: 24px 16px 24px 24px;
  .search_view {
    display: flex;
    .search {
      display: flex;
      width: 300px;
      height: 40px;
      .el-button {
        width: 40px;
        height: 40px;
        background: #1890ff;
        color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #1890ff !important;
        border-radius: 0px 4px 4px 0px !important;
        i {
          display: inline-block;
        }
      }

      ::v-deep .el-input__inner {
        border-radius: 4px 0px 0px 4px !important;
      }
    }
  }
  .searchbtn {
    margin-left: 14px;
    margin-right: 12px;
  }
}
// 按钮
.operation_box {
  display: flex;
  opacity: 1;
  height: 40px;
  border-radius: 4px;
  ::v-deep .el-button {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 24px;
    color: #ffffff;
    letter-spacing: 1px;
    border: none !important;
    span > i {
      font-size: 14px !important;
      margin-right: 5px;
    }
  }
  .el-button:nth-child(1) {
    width: 74px;
    height: 40px;
    background: #1890ff;
  }
  .el-button:nth-child(2) {
    width: 127px;
    height: 40px;
    background: #64b5ff;
  }
  .el-button:nth-child(3) {
    width: 104px;
    height: 40px;
    background: #00d254;
    span > i {
      margin-right: -2px !important;
    }
  }
  .el-button:nth-child(4) {
    width: 127px;
    height: 40px;
    background: #64b5ff;
  }
}
// 表单
.examinee_form {
  padding: 0 24px;
  p {
    padding: 10px 24px;
    height: 42px;
    background: #eef7ff;
    opacity: 1;
    border-radius: 4px 4px 0px 0px;
    font-weight: 400;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;

  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.red {
  color: #ff0000;
  padding: 8px;
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
  ::v-deep .el-pagination__jump {
    &::before {
      content: "10条/页";
      width: 82px;
      border: 1px solid #d9d9d9;
      height: 28px;
      border-radius: 2px;
      text-align: center;
      display: inline-block;
      margin-right: 8px;
      cursor: pointer;
    }
  }
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
}
::v-deep .el-table td div:nth-child(1) {
  text-align: center;
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
}
.learning_time {
  display: flex;
  align-items: center;
  padding: 14px 0px;
  h5 {
    display: inline-block;
    min-width: 142px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: left;
    line-height: 40px;
    padding-left: 20px;
    &::before {
      content: "*";
      width: 20px;
      display: inline-block;
      color: #ff0000;
    }
    &:nth-child(3) {
      margin-left: 57px;
    }
  }
  > div {
    display: flex;
    align-items: center;
    > .el-input {
      width: 100px;
      // height: 80px;
    }
    p {
      span {
        margin: 0px 6px;
      }
    }
  }
}
.exam_num {
  width: 60px;
}
.ip_view {
  display: flex;
  align-items: center;
  margin-left: 24px;
}
.ip_left {
  > p {
    margin-bottom: 24px;
    font-size: 16px;
  }
}
.ip_input {
  display: flex;
  align-items: center;
  margin-left: 24px;
  margin-bottom: 16px;
  .el-input {
    width: 160px;
  }
}
.notes_input {
  display: flex;
  align-items: center;
  margin-left: 24px;
}
.ip_ {
  display: flex;
  align-items: center;
  > .el-input {
    width: 60px;
  }
}
</style>
